import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { TitleFont } from '../../../libs/base/base-style';
import { styled } from '@mui/material/styles';
import { Stack } from '@mui/system';
import Grid from '@mui/material/Grid';
import { getEventById } from './utils';
import dayjs from 'dayjs';
import config from '../../../config'
import { Link } from 'react-router-dom';
import Upload from './Upload';
const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    outline: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: {
        xs: '100%',
        sm: 'inherit'
    }
};

// const Title = styled(TitleFont)`
//     font-size: 20px;
//     margin-right: 40px;
//     font-weight: 600;
//     font-family: inherit;
//     color: #408697;
// `
// const Content = styled(TitleFont)`
//     font-size: 20px;
//     font-weight: 300;
//     font-family: inherit;
//     color: #000;
// `
export const Title = styled(TitleFont)(({ theme }) => ({
    fontSize: '20px',
    marginRight: '40px',
    fontWeight: 600,
    fontFamily: 'inherit',
    color: '#408697',
    [theme.breakpoints.down('sm')]: {
        fontSize: '1.5rem',

    },
}));
export const Content = styled(TitleFont)(({ theme }) => ({
    fontSize: '20px',
    fontWeight: 300,
    fontFamily: 'inherit',
    color: '#000',
    [theme.breakpoints.down('sm')]: {
        fontSize: '1.5rem',

    },
}));
const ResStack: React.FC<React.PropsWithChildren> = (props) => {
    return <Stack sx={{
        flexDirection: {
            xs: 'coloumn',
            sm: 'row'
        }
    }}>{props.children}</Stack>
}

const isValidUrl = urlString => {
    var inputElement = document.createElement('input');
    inputElement.type = 'url';
    inputElement.value = urlString;

    if (!inputElement.checkValidity()) {
        return false;
    } else {
        return true;
    }
}
const App: React.FC<{
    open: boolean, close: () => void,
    event_type?: number | string,
    last_visit?: string | number | Date,
    video_url?: string,
    reminder_date?: string | number | Date,
    notes?: string,
    subtitle?: string,
    noReminder?: boolean,
    rename?: string,
    config?: any
    id?: string
    visitId?: string
}> = (props) => {
    const [open, setOpen] = React.useState(props.open);

    return (
        <div>
            <Modal
                open={props.open}
                onClose={props.close}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Grid container>
                        <Grid item xs={12} sm={6} mb={5}>
                            <ResStack>
                                <Title>  {props.subtitle ? props.subtitle : `Last ${getEventById({ _ID: Number(props.event_type) })} Visit:`}</Title>
                                <Content>{dayjs(props.last_visit).format('ddd, D MMM, YYYY') as string}</Content>
                            </ResStack>
                        </Grid>
                        <Grid item xs={12} sm={6} mb={5}>
                            {props.noReminder === true ? null : <ResStack>
                                <Title>  {props.config?.reminderLable ? props.config?.reminderLable : `${getEventById({ _ID: Number(props.event_type) })} Reminder:`}</Title>
                                <Content>{props.reminder_date == 'Unavailable' ? 'Unavailable' : dayjs(props.reminder_date).format('DD/MM/YY') as string}</Content>
                            </ResStack>}

                        </Grid>
                        {props.config?.videoTextfield == true ?
                            <Grid item xs={12} sm={12} mb={5}>
                                <ResStack>
                                    <Title>  {props.config?.videoTextLabel ? props.config?.videoTextLabel : `${getEventById({ _ID: Number(props.event_type) })} Video:`}</Title>
                                    <Content>{props.video_url && isValidUrl(props.video_url) == true ? <a href={String(props.video_url)} target="_blank">{props.video_url}</a> : props.video_url}</Content>
                                </ResStack>

                            </Grid>
                            : null}
                        <Grid item xs={12} mb={5}>
                            <Upload customField={{ event_type: String(props.event_type) }} visitId={props.visitId} />
                        </Grid>

                        <Grid item xs={12} mb={5}>
                            <ResStack>
                                {props.config?.renameNotes ? <Title>  {props.config?.renameNotes}</Title> : <Title>  {`Notes:`}</Title>}
                                <Content>{props.notes}</Content>
                            </ResStack>
                        </Grid>
                    </Grid>
                </Box>
            </Modal>
        </div>
    );
}
export default App

const smallStyle = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 450,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};
export const SharePage: React.FC<{ open: boolean, close: () => void, shareKey: string, profileId?: string }> = (props) => {
    const [open, setOpen] = React.useState(props.open);
    const handleClose = () => setOpen(false);

    return (
        <Modal
            open={props.open}
            onClose={props.close}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={smallStyle}>
                <Typography id="modal-modal-title" variant="h6" component="h2">
                    Text in a modal
                </Typography>
                <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                    Duis mollis, est non commodo luctus, nisi erat porttitor ligula.
                </Typography>
                <Grid container>
                    <Grid item xs={12} >
                        <Stack direction={'row'}>
                            {props.profileId ? <Title>  {`Share Url:`}</Title> :
                                <Title>  {`Profile has not been created.`}</Title>
                            }

                        </Stack>
                        <Stack direction={'row'} mt={2}>
                            <Content><a>{`${config.url}/share-profile/#/${props.shareKey}`}</a></Content>
                        </Stack>

                    </Grid>
                </Grid>
            </Box>
        </Modal>

    );
}